module.exports = __webpack_public_path__ + "static/media/nft-lending-icon1.688d9120.svg";